/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_DeclineInputs */

const en_booking_decline = /** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline & Refund`)
};

const es_booking_decline = /** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar y Reembolsar`)
};

const fr_booking_decline = /** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser et Rembourser`)
};

const de_booking_decline = /** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen & Erstatten`)
};

const id_booking_decline = /** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak & Kembalikan Dana`)
};

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const ja_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const zh_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const ar_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const it_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const ru_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const pt_booking_decline = en_booking_decline;

/** @type {(inputs: Booking_DeclineInputs) => LocalizedString} */
const ko_booking_decline = en_booking_decline;

/**
* | output |
* | --- |
* | "Decline & Refund" |
*
* @param {Booking_DeclineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_decline = /** @type {((inputs?: Booking_DeclineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_DeclineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_decline(inputs)
	if (locale === "es") return es_booking_decline(inputs)
	if (locale === "fr") return fr_booking_decline(inputs)
	if (locale === "de") return de_booking_decline(inputs)
	if (locale === "ja") return ja_booking_decline(inputs)
	if (locale === "zh") return zh_booking_decline(inputs)
	if (locale === "ar") return ar_booking_decline(inputs)
	if (locale === "id") return id_booking_decline(inputs)
	if (locale === "it") return it_booking_decline(inputs)
	if (locale === "ru") return ru_booking_decline(inputs)
	if (locale === "pt") return pt_booking_decline(inputs)
	return ko_booking_decline(inputs)
});